import { SubscriptionService, config } from '..';
import {
  FETCH_PAYMENT_SUCCESS,
  FETCH_PAYMENT_FAILED,
  CLEAR_PAYMENT,
} from '../../actionTypes';

export default (token) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_PAYMENT });

    const response = await SubscriptionService.get(
      '/user/payment-info',
      config(token)
    );
    const {
      data: { message, data },
    } = response;
    dispatch({
      type: FETCH_PAYMENT_SUCCESS,
      message,
      results: data,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: FETCH_PAYMENT_FAILED, error });
  }
};
